"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaListState = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const ListState_1 = require("./ListState");

const types_1 = require("./types");

class AlphaListState extends ListState_1.ListState {
  /** Constructor for AlphaListState model Objects. Supports list services that use next-token paging. */
  constructor(options) {
    super(options);
    Object.assign(this, Object.assign({
      cacheNextTokens: false,
      contentType: '',
      currentPage: '',
      goNext: true,
      nextPage: '',
      pageSearch: '',
      pageSearchList: []
    }, options));
  }
  /** Goes to the next page. Will store the current `pageSearch` in `pageSearchList` if `cacheNextTokens` is true. */


  goToNextPage() {
    this.goNext = true;

    if (this.cacheNextTokens) {
      this.pageSearchList.push(this.pageSearch);
    }

    this.pageSearch = this.nextPage;
  }
  /** Goes to the previous page, from `pageSearchList` if `cacheNextTokens` is true, otherwise `currentPage`. */


  goToPreviousPage() {
    this.goNext = false;
    this.pageSearch = this.cacheNextTokens ? this.pageSearchList.pop() : this.currentPage;
  }
  /** Returns true if there is a next page. */


  hasNextPage() {
    return this.nextPage.length > 0;
  }
  /** Returns true if there is a previous page. */


  hasPreviousPage() {
    return this.cacheNextTokens ? this.pageSearchList.length > 0 : this.currentPage.length > 0;
  }
  /** Resets all internal properties for query params. */


  resetParams() {
    Object.assign(this, {
      contentType: '',
      currentPage: '',
      goNext: true,
      nextPage: '',
      pageNumber: 1,
      pageSearch: '',
      pageSearchList: []
    });
  }
  /** Sets a new page size and calls `resetParams` if it differs from the current page size. */


  setPageSize(newPageSize) {
    if (newPageSize > 0 && newPageSize !== this.pageSize) {
      // valid size for page
      this.pageSize = newPageSize;
      this.resetParams();
    }
  }
  /** Gets the paging properties from response headers and sets them to internal properties. */


  setResponseAndHeaders(response, headers) {
    this.contentType = headers.get(types_1.JIL_HEADERS.CONTENT_TYPE) || '';
    this.currentPage = headers.get(types_1.JIL_HEADERS.CURRENT_PAGE) || '';
    this.nextPage = headers.get(types_1.JIL_HEADERS.NEXT_PAGE) || '';
    this.hasContent = response.length > 0 || this.filterQuery.length >= this.filterQueryMinLength;
  }
  /** Calls `ListState.setSortKeyAndReverseIfSameKey` and `resetParams`. */


  setSortKeyAndReverseIfSameKey(sortKey) {
    super.setSortKeyAndReverseIfSameKey(sortKey);
    this.resetParams();
  }
  /** Returns true if the given `value` does not match `filterQuery`. Will call `resetParams` if true. */


  shouldRefreshOnSearch(value) {
    if (value !== this.filterQuery) {
      this.resetParams();
      this.filterQuery = value;
      return true;
    }

    return false;
  }
  /** Returns a collection of data to send to services to handle pagination. */


  toQueryParams() {
    return {
      page_search: this.pageSearch,
      page_size: // page size should always be a positive integer, if using cached next tokens.
      this.cacheNextTokens || this.goNext ? this.pageSize : this.pageSize * -1,
      search_query: this.filterQuery,
      sort: this.sortKey,
      sort_order: this.sortReverse ? types_1.SortOrder.DESC : types_1.SortOrder.ASC
    };
  }

}

exports.AlphaListState = AlphaListState;
exports.default = AlphaListState;